import axios from "axios";
import { TTP_API_URL } from "Config";

export const sendGenericEmail = (
  token,
  recipients,
  type,
  lng,
  dynamicFields,
  organization,
  files
) => {
  const requestUrl = `${TTP_API_URL}/mailing/generic-email/send`;
  let formData = new FormData();
  formData.append("access_token", token);
  formData.append("recipients", JSON.stringify(recipients));
  formData.append("app", "EMAILING");
  formData.append("type", type);
  formData.append("language", lng);
  formData.append("dynamicFields", JSON.stringify(dynamicFields));
  formData.append("organization", organization);
  if (files.length > 0)
    for (let i = 0; i < files.length; i++) {
      formData.append(`file[${i}]`, files[i], files[i].name);
    }
  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/TamtamAPI/emailing.js